// Remembers where staff opened a student from, so the trail can lead back to
// that classroom rather than the generic Students list.
// Kept in sessionStorage so a refresh keeps the trail; storage can be blocked,
// so every access falls back to the in-memory value.

const STORAGE_KEY = 'breadcrumbOrigin';

let origin = null;

export const setBreadcrumbOrigin = (value) => {
  origin = value;
  try {
    if (value) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    else sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {}
};

export const getBreadcrumbOrigin = () => {
  if (origin) return origin;
  try {
    origin = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
  } catch (error) {}
  return origin;
};
